import React, { useState, useEffect, useMemo } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { TbEdit,TbEye } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ViewDetails from "./Assets/TaskDetailsModel.js";

const TaskDetails = () => {
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [departmentFilter, setDepartmentFilter] = useState("");
const [employeeFilter, setEmployeeFilter] = useState("");
    const [departmentDetails, setDepartmentDetails] = useState([]);
  const [roleDetails, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [taskDetailsCollection, setTaskDetailsCollection] = useState([]);
  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("date-desc");
  const [currentPage, setCurrentPage] = useState(1);
    const [viewTaskDetailsModel, setViewTaskDetailsModel] = useState(false);
     const [itemToView, setItemToView] = useState(null);
  const itemsPerPage = 30;
    const navigate = useNavigate();
  const Auth = localStorage.getItem("authToken");
  const userDepartment = localStorage.getItem("UserDepartment") || 1;
  useEffect(() => {
    fetchTasks();
    fetchUsers();
  }, []);
  const fetchUsers = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-data-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      if (!response.ok) throw new Error("Failed to fetch users");
      
      const result = await response.json();
      setUsers(result.users || []);
      setRoles(result.roles || []);
      let departmentsData = [];
      if (Array.isArray(result.departments)) {
        departmentsData = result.departments;
      } else if (result.departments?.data && Array.isArray(result.departments.data)) {
        departmentsData = result.departments.data;
      }
      setDepartmentDetails(departmentsData);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError(err.message);
      setLoading(false);
    }
  };
// fetch al data
  const fetchTasks = async () => {
    try {
      const response = await fetch("https://backend.sanchalansetu.com/api/v1/get-completed-task-list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const result = await response.json();
      setTasks(result || []);
      setUsers(result.team_members || []);
      setTaskDetailsCollection(result || []);
      /* const formattedTasks = (result || []).map((task) => {
      const fromUser = result.team_members.find((u) => u.id === task.from_user);
      const toUser = result.team_members.find((u) => u.id === task.to_user);

      return {
        id: task.task_group_id,
        title: task.title,
        from_user: fromUser ? fromUser.name : `${task.from_user}`,
        to_user: toUser ? toUser.name : `${task.to_user}`,
        created_at: task.created_at,
      };
    }); */

    
      
      setLoading(false);
    } catch (err) {
      console.error("Error fetching tasks:", err);
      setError(err.message);
      setLoading(false);
    }
  };
  

  
  const filteredTasks = useMemo(() => {
  const today = new Date();

  let filtered = taskDetailsCollection.filter((t) => {
    const titleMatch = t.title?.toLowerCase().includes(search.toLowerCase());
    const fromUserMatch = t.from_user_name?.toLowerCase().includes(search.toLowerCase());
    const toUserMatch = t.to_user_name?.toLowerCase().includes(search.toLowerCase());

    

    let employeeMatch = true;
    if (employeeFilter) {
      employeeMatch =
        t.from_user_id == employeeFilter ||
        t.to_user == employeeFilter ||
        t.team_members?.some((m) => m.user_id == employeeFilter);
    }

    // Date filter
    let matchesDate = true;
    if (daysFilter) {
      const createdDate = new Date(t.created_at);
      if (!isNaN(createdDate)) {
        const diffTime = today - createdDate;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        matchesDate = diffDays <= parseInt(daysFilter);
      } else {
        matchesDate = false;
      }
    }

    return (
      (titleMatch || fromUserMatch || toUserMatch) &&
      matchesDate &&
      employeeMatch
    );
  });


  return filtered;
}, [taskDetailsCollection, search, daysFilter, sortOption,  employeeFilter]);
const filteredUsers = useMemo(() => {
  if (!departmentFilter) return []; 
  return users.filter((u) => u.department_id == departmentFilter);
}, [users, departmentFilter]);
  // Pagination method
  const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentTasks = filteredTasks.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };





      const handleViewClick = (id) => {
      navigate(`/task-details/${id}`);
    };



/*         const cancelView = () => {
      setViewTaskDetailsModel(false);
      setItemToView(null);
    }; */

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;


  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Completed Task Details</h2>

      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by task Title..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />
        {userDepartment <= 3 && (
        <select
          value={departmentFilter}
          onChange={(e) => {
            setDepartmentFilter(e.target.value);
            setEmployeeFilter(""); 
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">Select Department</option>
          {departmentDetails.map((d) => (
            <option key={d.id} value={d.id}>
              {d.name}
            </option>
          ))}
        </select>
        )}
        {userDepartment <= 3 && (
        <select
          value={employeeFilter}
          onChange={(e) => {
            setEmployeeFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
          disabled={!departmentFilter} // optional UX improvement
        >
          <option value="">Select Employee</option>

          {filteredUsers.map((user) => (
            <option key={user.id} value={user.id}>
              {user.name}
            </option>
          ))}
        </select>
        )}
        <select
          value={daysFilter}
          onChange={(e) => {
            setDaysFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>

        <select
          value={sortOption}
          onChange={(e) => {
            setSortOption(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
        </select>
      </div>

      
      <table className="w-full text-sm border task-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">Task Title</th>
            <th className="px-4 py-2 text-left">Assigned By</th>
            <th className="px-4 py-2 text-left">Assigned To</th>
            <th className="px-4 py-2 text-left">Created At</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentTasks.length > 0 ? (
            currentTasks.map((t, index) => (
              <tr key={t.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2">{t.title || "N/A"}</td>
                <td className="px-4 py-2">{t.from_user_name || "N/A"}</td>
                <td className="px-4 py-2">
                  <div className="flex items-start -space-x-4">
                    {t.team_members.map((member, index) => (
                      <div
                        key={member.user_id}
                        className="relative group"
                        style={{ zIndex: t.team_members.length - index }}
                      >
                        <img
                          src={member.avatar}
                          alt={member.user_name}
                          className="w-10 h-10 rounded-full border-2 border-white shadow-sm cursor-pointer transition-all duration-200 group-hover:z-50 group-hover:-translate-y-1"
                          title={member.user_name}
                        />
                        
                        <div className="absolute bottom-full mt-2 left-1/2 transform -translate-x-1/2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded">
                          {member.user_name}
                        </div>
                      </div>
                    ))}
                  </div>
                </td>


                <td className="px-4 py-2">{formatDateTime(t.created_at || t.createdAt)}</td>
                <td className="px-4 py-2 flex gap-2">
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleViewClick(t.task_group_id)}>
                    <TbEye size={22}  />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center py-4 text-gray-500">
                No tasks found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      
      
    </div>
  );
};

export default TaskDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

